<template>
    <footer :class="{active:pathUrl === 'home' && drainageShow === '1'}">
        <div :class="['footer-box',{active:pathUrl === 'home'}]">
            <div class="footer-left">
                <div class="zh-logo">
                    <img class="img-logo" alt="中海幸福家" src="https://xfjoss.coli688.com/pc-images/big-footer.png">
                </div>
                <div class="big-text-icon"></div>
                <div class="footer-con">
                    <ul class="footer-nav-list">
                        <!-- <li><a href="https://www.coli688.com/" style="color:#3E3E3E;" target="_Blank">友情链接</a></li> -->
                        <li class="weight">友情链接</li>
                        <span class="text-icon">｜</span>
                        <li><a href="https://www.coli688.com" target="_Blank" rel="nofollow">中海地产</a></li>
                        <li><a href="https://www.cohl.com" target="_Blank" rel="nofollow">中海集团</a></li>
                    </ul>
                    <ul class="footer-nav-list">
                        <!-- <li><a href="https://www.coli688.com/" style="color:#3E3E3E;" target="_Blank">友情链接</a></li> -->
                        <li  class="weight">网络经营许可证</li>
                        <span class="text-icon">｜</span>
                        <li>粤ICP备05098081号-1  © Copyright©2022-2023 中海地产 版权所有</li>
                    </ul>
                    <!-- <div class="footer-capy">网络经营许可证粤ICP备05098081号-1  © Copyright©2022-2023 中海地产 版权所有</div> -->
                </div>
            </div>
            <div class="footer-right">
                <img class="img-wx-code" alt="中海幸福家小程序" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220531_183744302d86429c384fdd837062b9690b50fd.jpg">
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'ZhFooter',
  data () {
    return {
        pathUrl: '',
        drainageShow: '0',
    }
  },
  watch: {
    '$route.path' (val) {
        const drainageShow = localStorage.getItem('drainageShow')
        this.drainageShow = drainageShow || '1'
        this.pathUrl = val === '/' ? 'home' : ''
    },
  },
  mounted () {
    const drainageShow = localStorage.getItem('drainageShow')
    this.drainageShow = drainageShow || '1'
    this.pathUrl = this.$route.path === '/' ? 'home' : ''
  },
}
</script>
<style lang="scss" scoped>
footer{
    width: 100%;
    height:160px;
    color: #FFFFFF;
    &.active{
        height:210px;
    }
}
.footer-box{
    width: 1180px;
    padding: 45px 12px 0;
    margin: 0 auto;
    height: 100%;
    border-top: 1px solid #E6E6E6;
    display: flex;
    justify-content: space-between;
    .footer-left{
        display: flex;
        .zh-logo{
            width: 77px;
            height: 60px;
            .img-logo{
                width: 160px;
                height: 82px;
            }
        }
        .big-text-icon {
            height: 82px;
            margin-left: 100px;
            border: 1px solid #DFE4E8;
        }
        .footer-con{
            margin-left: 20px;
            color: #A3AFBB;
                // &ul {
                //     padding-top: 20px;
                // }
                
                .footer-nav-list{
                    display: flex;
                    padding-top: 10px;
                    line-height: 28px;
                    .text {
                        color: rgba(163, 175, 187, 1);
                        font-size: 14px;
                        font-family: PingFangSC-Regular;
                    }
                    .weight {
                        font-weight: 600;
                    }
                    li{
                        margin-left: 4px; 
                        margin-right: 4px;  
                        font-family: PingFangSC-Regular, PingFang SC;
                        a{
                            font-size: 14px;
                            color: #A3AFBB;
                        }
                    }
                }
                .footer-capy{
                    margin-top: 24px;
                    font-size: 12px;

                }
        }
    }
    .footer-right{
        width: 120px;
        height: 120px;
        transition: transform .5s ease .5s;
        margin-top: -15px;
        &:hover {
            transform: scale(2);
        }
        .img-wx-code{
            width: 120px;
            height: 120px;
        }
    }
}
</style>
